export default __webpack_public_path__ + "static/media/H_Underlay.9b038f66.jpg";